import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { MdsConfig } from '@maersk-global/mds-config';
import { environment } from './environments/environment';
import { RumInit } from '@maersk-global/telemetry-web-sdk';

//MdsConfig.iconsDynamicImportPath = process.env.NODE_ENV === 'development' ? '/node_modules/' : '/assets/node_modules/';

// mds icons are dynamically imported from the assets folder
// MdsConfig.iconsDynamicImportPath = `/${currentLocale}/assets/`;

// MdsConfig.iconsDynamicImportPath = '/reliability/badactor/assets/';

// if (window.location.href.includes("localhost")) {
//   MdsConfig.iconsDynamicImportPath = '/assets/';
// }

MdsConfig.iconsDynamicImportPath = window.location.href.includes("digitalam") ? '/reliability/badactor/assets/' : '/assets/';

//Real User Monitoring Integration for akamai URL's
if (window.location.href.includes("clientdev") || window.location.href.includes("clienttest") || window.location.href.includes("clientprep")) {
  const appName = environment.rumConfig.appName
  const apiKey = environment.rumConfig.apiKey
  const env = environment.rumConfig.appName.split("-")[1]
  RumInit({
    app: {
      environment: env,
      name: appName,
      version: "1.0.0",
    },
    apiKey: apiKey,
    debug: false,
    traceLog: true,
    useSendBeacon: true,
    propagateTraceHeaderCorsUrls: [/https?:\/\/.*/]
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
